import { css } from '@/styled-system/css';

export const flexContainerStyles = css.raw({
  display: 'flex',
  flexDirection: { base: 'column', lg: 'row' },
  alignItems: 'center',
  padding: '400',
  minHeight: '94px',
  backgroundColor: 'bg.neutral',
  border: '1px solid {colors.border.subtle}',
  borderRadius: '3px',
  justifyContent: { base: 'space-evenly', lg: 'space-between' },
  marginBottom: '400',
});

export const rightSubFlexContainerStyles = css.raw({
  display: 'flex',
  flexGrow: 2,
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  order: { base: 0, lg: 5 },
  width: '100%',
  justifyContent: { base: 'center', lg: 'flex-end' },
});
